import { Component, OnInit, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter, map, mergeMap } from 'rxjs';
import { Title } from '@angular/platform-browser';
import { ThemeService } from './services/theme.service';
import { HostApplicationService } from './services/host-application.service';
import { AUTH_SERVICE_TOKEN, IAuthService } from './services/auth/auth.interface';

@Component({
  selector: 'app-root',
  standalone: true,
  providers: [],
  imports: [
    CommonModule,
    RouterOutlet
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  title = 'Aura AI';
  isLoading = true;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private titleService: Title,
    private theme: ThemeService,
    @Inject(AUTH_SERVICE_TOKEN) private authService: IAuthService,
    private hostApplicationService: HostApplicationService,
  ) {
    this.hostApplicationService.onThemeUpdated$.subscribe(async (theme: string) => {
      this.switchTheme(theme);
    });
  }

  get isAuthenticated(): boolean {
    return this.authService.userToken$ != null;
  }

  async ngOnInit(): Promise<void> {
    try {
      // Change page title on navigation or language change, based on route data
      const onNavigationEnd = this.router.events.pipe(filter(event => event instanceof NavigationEnd));
      onNavigationEnd.pipe(
        map(() => {
          let route = this.activatedRoute;
          while (route.firstChild) {
            route = route.firstChild;
          }
          return route;
        }),
        filter(route => route.outlet === 'primary'),
        mergeMap(route => route.data)
      )
        .subscribe(async event => {
          const path = this.router.url;
          // if (path.startsWith('/login')) {
          // }

          this.title = event['title'];
          if (this.title) {
            this.titleService.setTitle(this.title);
          }
        });

      // Set initial theme
      let theme = await this.hostApplicationService.getCurrentTheme();
      if (theme !== null) {
        this.switchTheme(theme);
      }
    }
    finally {
      this.isLoading = false;
    }
  }

  // Switch theme based on user selection
  switchTheme(theme: string): void {
    switch (theme) {
      case 'light':
        this.theme.current = 'light';
        break;
      case 'dark':
        this.theme.current = 'dark';
        break;
      default:
        this.theme.setSystemTheme();
        break;
    }
    localStorage.setItem('selectedTheme', theme);
  }

}
